import React from "react";
import "./index.scss";
import { CreateIcon } from "@assets/icons/CreateIcon";

const CreateModal = ({ isOpen, children, toggleModal, title, style }) => {
  if (!isOpen) return null;

  return (
    <div className="create-modal__wrapper">
      <div
        className="create-modal__overlay"
        onClick={() => toggleModal(<></>)}></div>
      <div className="create-modal__container" style={{ ...style }}>
        <div className="create-modal__titleContainer">
          <h2 className="create-modal__title">{title}</h2>
          <CreateIcon />
        </div>
        {children}
      </div>
    </div>
  );
};

export default CreateModal;
